<div class="mibarra w-100 my-2 my-lg-3">
    <div class="container-fluid">
        <div class="col-md-12 justify-content-start">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="step-text" *ngIf="actualStep.length > 0">
                    <strong class="d-none d-sm-inline">Paso {{activeStep+1}} de {{ actualStep.length }}:</strong>
                    {{actualStep[activeStep]}}
                </div>
                <div *ngIf="activeStep+1 !== lenthActualStep && nextStep.length > 0" class="next-stop-text">Siguiente:
                    {{nextStep[activeStep]}}
                </div>
            </div>
            <div class="container-fluid p-2 align-items-center">
                <div class="d-flex justify-content-around">
                    <span *ngFor="let step of [].constructor(lenthActualStep); let i = index"
                        [ngClass]="{'bg-custom': i < activeStep, 'bg-custom-actual': i === activeStep , 'bg-custom-success': i > activeStep}" 
                        class="bg-success width-fill rounded mt-auto mb-auto me-1 ms-1 d-flex justify-content-center align-items-center"
                        style="height: 0.3rem">
                        <img *ngIf="i === activeStep" src="./assets/img/svg/casa-blanca.svg" alt="Cheque" class="motico-border"
                            style="width: 25px; height: 25px">
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>